import { render, staticRenderFns } from "./factoraje.vue?vue&type=template&id=08e7a754&"
import script from "./factoraje.vue?vue&type=script&lang=js&"
export * from "./factoraje.vue?vue&type=script&lang=js&"
import style0 from "./factoraje.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports